angular.module('unica_hotel.hotel_controllers')

.controller('HotelCreateController', function(
	$rootScope, $scope, $state,
	HotelCreateService
) {

	$scope.pageTitle = 'Aggiungi Hotel';

	$scope.resetHotelData();

	$scope.addRoomType();

	function createHotel()
	{
		HotelCreateService
			.create( $scope.hotelData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Hotel aggiunto con successo!', '');
					$state.go('app.hospitality.hotel_list');
				} else {
					$rootScope.manageError(data);
				}
			});
	}


	$scope.saveHotel = function () {
		$scope.showLoader();

		if ( !$scope.hotelData.latitude && !$scope.hotelData.longitude ) {
			$scope.geocoder.geocode({
				address: $scope.hotelData.address
			}, function(responses) {
				if (responses && responses.length > 0) {
					$scope.hotelData.latitude  = responses[0].geometry.location.lat();
					$scope.hotelData.longitude = responses[0].geometry.location.lng();

					createHotel();
				}
			});
		} else {
			createHotel();
		}
	};

});




